import './Modal.css';
import React, { useEffect, createRef } from 'react'; // eslint-disable-line

import { ReactComponent as IconClose } from '../../../resources/icons/close.svg';
import { ReactComponent as IconCloseSharedCh } from '../../../resources/icons/closeSharedCh.svg';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import ReactDOM from 'react-dom';
import clsx from 'clsx';
import { canUseDOM } from '../../../utils';
const Modal = _ref => {
  let {
    isShown,
    hide,
    style,
    children,
    primaryColor,
    primaryActiveColor,
    fullPageCover = false,
    fullPageVideo = false,
    showMobileClose = false,
    isSharedCh = false
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const modalRef = /*#__PURE__*/createRef();
  const variables = {
    '--modal-primary-color': primaryColor || 'var(--main-color)',
    '--modal-primary-active-color': primaryActiveColor || 'var(--main-color--active)'
  };
  const onModalClose = e => {
    if (isShown) {
      hide();
    }
  };
  useEffect(() => {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      isShown ? document.querySelector('html').style.overflow = 'hidden' : document.querySelector('html').style.overflow = 'unset';
      const keyListener = e => {
        const listener = keyListenersMap.get(e.keyCode);
        return listener && listener(e);
      };
      document.addEventListener('keydown', keyListener);
      return () => document.removeEventListener('keydown', keyListener);
    }
  });
  useEffect(() => {
    if (canUseDOM) {
      const node = modalRef.current;
      if (node && isShown) {
        node.focus();
      }
    }
  }, [isShown]);
  const keyListenersMap = new Map([[27, onModalClose]]);
  const modal = /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables,
    isSharedCh: isSharedCh
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('modal-backdrop', {
      'full-page-video-backdrop': fullPageVideo
    }),
    onClick: hide
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('modal', {
      'full-page': fullPageCover
    }, {
      'full-page-video': fullPageVideo
    }, {
      'mobile-close-visible': showMobileClose
    }),
    style: style
  }, ' ', /*#__PURE__*/React.createElement("div", {
    className: "modal-inner",
    tabIndex: 0,
    ref: modalRef,
    "aria-modal": true,
    "aria-labelledby": "modal",
    role: "dialog"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal__header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "modal__close-btn",
    type: "button",
    onClick: hide,
    tabIndex: 0
  }, isSharedCh ? /*#__PURE__*/React.createElement(IconCloseSharedCh, {
    tabIndex: -1
  }) : /*#__PURE__*/React.createElement(IconClose, {
    tabIndex: -1
  }))), /*#__PURE__*/React.createElement("div", {
    className: "modal__content"
  }, " ", children)))));
  return isShown ? /*#__PURE__*/ReactDOM.createPortal(modal, document.body) : null;
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    style,
    isSharedCh
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `  ${eventStyle}  ${rtl ? rtlStyle : ltlStyle} ${isSharedCh && !rtl && sharedChEventStyle} ${isSharedCh && rtl && sharedChLtrStyle} `,
    style: style
  }, children);
};
const sharedChEventStyle = "sfuyw27";
const sharedChLtrStyle = "s115be6b";
const eventStyle = "ebe585r";
const rtlStyle = "rzfft05";
const ltlStyle = "lq1v071";
export default Modal;